export default __webpack_public_path__ + "static/media/rings1.842ed0bd.webp";